import baseRoute from '../baseRoute';

export default `${baseRoute}/organization` as const;
